module.exports = __webpack_public_path__ + "img/shopee.afb14466.png";